module.exports = __webpack_public_path__ + "img/ad03.e23c762b.png";